export const SITE_URL =
  process.env.REACT_APP_SITE_URL || 'https://www.nexting-etudes.tn';

export const SEO_CONFIG = {
  siteName: 'Leaders Nexting',
  defaultTitle: 'Leaders Nexting',
  defaultDescription:
    'Nexting Études, bureau d\'études en ingénierie du bâtiment à Tunis : études structurelles, études d\'exécution, suivi et pilotage de chantier. Expertise en génie civil pour vos projets en Tunisie.',
  defaultKeywords:
    'bureau d\'études Tunis, ingénierie bâtiment Tunisie, études structurelles, génie civil Tunis, suivi de chantier, études d\'exécution, Nexting Études, construction Tunis',
  defaultImage: '/images/hero_slider_1.png',
  language: 'fr',
  locale: 'fr_TN',
  twitterHandle: '@nextingetudes',
  business: {
    name: 'Nexting Études',
    legalName: 'Nexting Études',
    description:
      'Bureau d\'études spécialisé en ingénierie du bâtiment, études techniques et suivi de chantier en Tunisie.',
    telephone: '+21600000000',
    email: 'Nexting@support.com',
    address: {
      streetAddress: 'Les Berges du lac 2, en face de clinique Hannibal',
      addressLocality: 'Tunis',
      addressRegion: 'Tunis',
      postalCode: '1053',
      addressCountry: 'TN',
    },
    geo: {
      latitude: 36.8381,
      longitude: 10.2408,
    },
    priceRange: '$$',
    areaServed: 'Tunisie',
  },
};

export const PAGE_SEO = {
  home: {
    title: 'Leaders Nexting',
    description:
      'Nexting Études accompagne vos projets de construction en Tunisie : études structurelles, plans d\'exécution, coordination et suivi de chantier. Demandez une étude personnalisée.',
    keywords:
      'bureau d\'études Tunis, ingénierie bâtiment, études structurelles Tunisie, suivi de chantier, génie civil',
    path: '/',
  },
  about: {
    title: 'À propos — Bureau d\'études en ingénierie du bâtiment',
    description:
      'Découvrez Nexting Études : 15 ans d\'expertise en ingénierie du bâtiment, génie civil et accompagnement de projets de construction en Tunisie.',
    keywords:
      'à propos Nexting Études, bureau d\'études Tunis, expertise génie civil, ingénierie bâtiment Tunisie',
    path: '/about',
  },
  services: {
    title: 'Services — Études structurelles & suivi de chantier',
    description:
      'Études structurelles, études d\'exécution, optimisation des coûts et pilotage de chantier. Nexting Études propose des solutions techniques fiables pour vos projets en Tunisie.',
    keywords:
      'études structurelles Tunis, études d\'exécution, suivi de chantier Tunisie, optimisation coûts construction, coordination chantier',
    path: '/service',
  },
  contact: {
    title: 'Contact — Demandez une étude ou un devis',
    description:
      'Contactez Nexting Études à Tunis (Les Berges du Lac). Téléphone, e-mail et formulaire pour vos demandes d\'études techniques et de suivi de chantier.',
    keywords:
      'contact bureau d\'études Tunis, devis études structurelles, Nexting Études contact, ingénierie bâtiment Tunis',
    path: '/contact',
  },
};

export const SITEMAP_ROUTES = [
  { path: '/', changefreq: 'weekly', priority: '1.0' },
  { path: '/about', changefreq: 'monthly', priority: '0.8' },
  { path: '/service', changefreq: 'monthly', priority: '0.9' },
  { path: '/contact', changefreq: 'monthly', priority: '0.8' },
];
